import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { BsDatabaseFill } from "react-icons/bs";

import PieChart from "../../../components/charts/PieChart";

const CallPurposeSection = ({ title = "Calls by Purpose" }) => {
  const { t } = useTranslation();
  const { calls, loading_calls } = useSelector((state) => state.analytics.analytics);

  const callsByPurpose = calls?.calls_by_purpose || {};
  const entries = Object.entries(callsByPurpose)
    .filter(([, count]) => count > 0)
    .sort((a, b) => b[1] - a[1]);
  const labels = entries.map(([label]) => label);
  const values = entries.map(([, count]) => count);
  const totalCalls = values.reduce((accumulator, value) => accumulator + value, 0);

  return (
    <Card
      className="w-full h-full rounded-md shadow-custom-light px-[32px] py-[20px]"
      shadow="none"
    >
      <CardBody className="w-full p-0 box-border">
        <div className="w-full flex items-center justify-between">
          <h6 className="text-[14px] font-medium text-gray-400 leading-none">{t(title)}</h6>
        </div>
        <div className="w-full h-full min-h-[300px] flex items-center justify-center mx-auto">
          {loading_calls && (
            <div className="flex flex-col justify-center items-center w-full h-96 m-auto text-sm">
              <CircularProgress
                aria-label={t("Loading...")}
                color="primary"
                label={t("Loading...")}
              />
            </div>
          )}
          {!loading_calls && totalCalls > 0 ? (
            <div className="w-full h-full min-h-[300px] max-h-[360px] flex items-center justify-center">
              <PieChart
                labels={labels}
                values={values}
              />
            </div>
          ) : !loading_calls ? (
            <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
              <BsDatabaseFill className="text-gray-300 w-12 h-12" />
              <h3 className="text-sm text-gray-400 mt-3">{t("No records to display")}</h3>
            </div>
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
};

export default CallPurposeSection;
